export const defaultRomeLongitude = 12.496366;
export const defaultRomeLatitude = 41.902782;

export const defaultMapStyle = "mapbox://styles/mapbox/satellite-v9";
export const lightMapStye = "mapbox://styles/mapbox/light-v10";
export const defaultRiskAssessmentMapStyle = "mapbox://styles/mapbox/streets-v12";

// Do not apply cspell after this line
// cspell:disable

export const buildingMapStyleName = "cystellarmapbox/cka9u0guo1lbj1jpd4qko857v"; // CyStellarRealeBuildingInfo
export const buildingMapStyle = "mapbox://styles/" + buildingMapStyleName;
export const agricultureMapStyleName = "cystellarmapbox/cliivz5oy00b701qvfpjoalvf"; // CYS-RealeRisk-AgricultureBase

export const riskEvaluationMapStyles = {
  // New Euro inland flood from EFAS, 2025 version
  inlandFloodEUR10YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdsrfbau00al01pj9mp44rx7", // EuropeFloodMap-10y
  inlandFloodEUR20YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdsp9sw0001d01scf0bd6dtk", // EuropeFloodMap-10y
  inlandFloodEUR30YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdspcmxj001e01scgx3texj0", // EuropeFloodMap-10y
  inlandFloodEUR40YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdspgb2p009d01r549ki8c6b", // EuropeFloodMap-10y
  inlandFloodEUR50YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdspj5mt001001sc56jaf35w", // EuropeFloodMap-10y
  inlandFloodEUR75YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdspm5lu00fm01qs0mdnfdxa", // EuropeFloodMap-10y
  inlandFloodEUR100YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdsrb7jl00ft01qsd9yp0cnb", // EuropeFloodMap-10y
  inlandFloodEUR200YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdsre7nd006w01shgcoh5665", // EuropeFloodMap-10y
  inlandFloodEUR500YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdsrfbau00al01pj9mp44rx7", // EuropeFloodMap-10y

  // New Ita inland flood from EFAS, 2025 version
  inlandFloodITA10YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdyh5e0r00au01sc5dtjep3q", // ItalyFloodMap-10y
  inlandFloodITA20YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdyh9oxj000t01qzdci7gec7", // ItalyFloodMap-20y
  inlandFloodITA30YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdyhbcr800aw01sce72lgt0e", // ItalyFloodMap-30y
  inlandFloodITA40YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdyhcr6o008501sb1nvi80w4", // ItalyFloodMap-40y
  inlandFloodITA50YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdyhdvoy00ay01scczki4h7i", // ItalyFloodMap-50y
  inlandFloodITA75YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdyhf4c300lj01pj1vkk6bbl", // ItalyFloodMap-75y
  inlandFloodITA100YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdyhfuzn00cr01sd72bh8t7j", // ItalyFloodMap-100y
  inlandFloodITA200YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdyhguom005t01r2dkkqhdvm", // ItalyFloodMap-200y
  inlandFloodITA500YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmdyhi9og00pu01qs10kha22y", // ItalyFloodMap-500y

  // USA, inland flood from EFAS, 2025 version
  inlandFloodUSA10YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmea1bu6z00bd01sdgniden69", // USAFloodMap-10y
  inlandFloodUSA20YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmebdibdl00qg01sc38nvad49", // USAFloodMap-20y
  inlandFloodUSA50YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmebdi7xk00q801sbhou1ezak", // USAFloodMap-50y
  inlandFloodUSA75YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmebdhx9j00q701sbhoqt3rju", // USAFloodMap-75y
  inlandFloodUSA100YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmebdhutv003401s6a2veh4qn", // USAFloodMap-100y
  inlandFloodUSA200YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmebdhr1b00fa01s65xg633aj", // USAFloodMap-200y
  inlandFloodUSA500YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmebdeuei001701qua5lzbopa", // USAFloodMap-500y

  // BRAZIL, inland flood from EFAS, 2025 version
  inlandFloodBRA10YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmecmy5do00gr01s6a3qz6f8q", // BRAFloodMap-10y
  inlandFloodBRA20YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmecmy1qx00rl01sbf17e2ckw", // BRAFloodMap-20y
  inlandFloodBRA50YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmecmxyuh00gq01s6fdqtgbkp", // BRAFloodMap-50y
  inlandFloodBRA75YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmecmv6sz00sv01pj49ay8p1p", // BRAFloodMap-75y
  inlandFloodBRA100YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmecmxm2z00rm01sc5652a2md", // BRAFloodMap-100y
  inlandFloodBRA200YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmecmxj67000x01sbe4mfgqug", // BRAFloodMap-200y
  inlandFloodBRA500YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cmecmxff1001g01sa2gis7509", // BRAFloodMap-500y

  // NatCat flood styles

  inlandFloodNatcatRiskStylePB: "mapbox://styles/cystellarmapbox/clw7if1sj02q301qv7kbd7gue",
  inlandFloodNatcatRiskStyle: "mapbox://styles/cystellarmapbox/cm2t3fy1500e901qw2upsf9td?v=5", // Howden-Flood-Tm1
  // inlandFloodNatcat58RiskStyle_pre_1343: "mapbox://styles/cystellarmapbox/cm557rpt400fm01sa818x9ejs", // RealeRisk_RMAHowden_Flood-58 before 1343
  inlandFloodNatcat58RiskStyle: "mapbox://styles/cystellarmapbox/cmdq36yrw005s01r55st3ew87", // RealeRisk_RMAHowden_Flood-58
  inlandFloodNatcat56RiskStyle: "mapbox://styles/cystellarmapbox/cmdn6ajku000v01r5b6dj8195", // RealeRisk_RMAHowden_Flood-58 2

  //Inland Flood Global Mapbox Styles
  inlandFloodGlobal10YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cklqw6e1f6onw17rz8yjuvb5p",
  inlandFloodGlobal20YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cklqw9pv16oc117qudgrzhht9",
  inlandFloodGlobal50YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/cklqwajt1483i17t6pd3wve7c",
  inlandFloodGlobal100YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/ckovfggtwecwg17p94gsih12t",
  inlandFloodGlobal500YearsMapBoxStyle: "mapbox://styles/cystellarmapbox/ckovfsi4a02vq18my2y4pz9p1",

  // Storm Surge (US)
  stormSurgeCategory1MapStyle: "mapbox://styles/cystellarmapbox/ckpo9520d0iiw18o8eg98c3c8",
  stormSurgeCategory2MapStyle: "mapbox://styles/cystellarmapbox/ckpo973i7027i17pdo2i0lsh0",
  stormSurgeCategory3MapStyle: "mapbox://styles/cystellarmapbox/ckpo97jk918nn17qg233h3vbg",
  stormSurgeCategory4MapStyle: "mapbox://styles/cystellarmapbox/ckpo9823218o617qgi4g00yjp",
  stormSurgeCategory5MapStyle: "mapbox://styles/cystellarmapbox/ckpo98fpo0tfs18ozcb6j1r20",

  //Coastal flood
  coastalFloodMapStyle10V1: "mapbox://styles/cystellarmapbox/ckhul582z4v4p19qtu4xu0g6g",
  coastalFloodMapStyle30V1: "mapbox://styles/cystellarmapbox/ckhul9w343pvf1anyb3i7sr5e",
  coastalFloodMapStyle100V1: "mapbox://styles/cystellarmapbox/ckhulbvzx0e2v19nxj4lb7uc0",
  coastalFloodMapStyle300V1: "mapbox://styles/cystellarmapbox/ckhuldh2c4uoe19t71rsshn81",
  coastalFloodMapStyle1000V1: "mapbox://styles/cystellarmapbox/ckhuleqrd51lt19kej3oeesyv",
  coastalFloodProtectionMapStyleV1: "mapbox://styles/cystellarmapbox/ckhuoi1aj0h7d19nxx0n6taom",
  coastalFloodNoProtectionMapStyleV1: "mapbox://styles/cystellarmapbox/ckhuof7ey0phv19pkwywq39e8",

  coastalFloodMapStyle10: "mapbox://styles/cystellarmapbox/cm35mwniu00bi01nwg9it2hlp", // EuropeCoastalFlood-10yr
  coastalFloodMapStyle30: "mapbox://styles/cystellarmapbox/cm35mwyi000w401pq1sndgi8b", // EuropeCoastalFlood-30yr
  coastalFloodMapStyle100: "mapbox://styles/cystellarmapbox/cm35mwjin00c601o0fn8v5i1g", // EuropeCoastalFlood-100yr
  coastalFloodMapStyle300: "mapbox://styles/cystellarmapbox/cm35mwu7a00p501qzdwpb4zom", // EuropeCoastalFlood-300yr
  coastalFloodMapStyle1000: "mapbox://styles/cystellarmapbox/cm35mwemh00bg01nwhqm6a1a6", // EuropeCoastalFlood-1000yr
  coastalFloodProtectionMapStyle: "mapbox://styles/cystellarmapbox/cm35n0h7400c801o0ckongrn2", // EuropeCoastalFloodExtent-WP
  coastalFloodNoProtectionMapStyle: "mapbox://styles/cystellarmapbox/cm35th8wd00q801qthzh5f8j2", // EuropeCoastalFloodExtent-NP

  //Flash flood
  flashFloodMapStyle: "mapbox://styles/cystellarmapbox/cktenjfzr2hg017p5vfjtfbvp",
  flashFlood3hMapboxStyleV1: "mapbox://styles/cystellarmapbox/cktenjfzr2hg017p5vfjtfbvp",
  flashFlood3hMapboxStyle: "mapbox://styles/cystellarmapbox/cm2uaj40x00i001pm9a3w00nv", // FlashFlood-3h-tm3
  flashFlood24hMapboxStyleV1: "mapbox://styles/cystellarmapbox/cktiuz0i46k4l17pp55qabbbq",
  flashFlood24hMapboxStyle: "mapbox://styles/cystellarmapbox/cm2uacqg000h501qw8raa5rg7", // FlashFlood-24h-tm3

  flashFlood48hMapboxStyleV1: "mapbox://styles/cystellarmapbox/cktlp1zdo10hj18o1vg7bvx18",
  flashFlood48hMapboxStyle: "mapbox://styles/cystellarmapbox/cm34nhysp001c01nw5i5h3582", // FlashFlood-48h-tm3

  flashFlood72hMapboxStyleV1: "mapbox://styles/cystellarmapbox/cktlpbj4v1y0c18jyq4iatz01",
  flashFlood72hMapboxStyle: "mapbox://styles/cystellarmapbox/cm34ni43q008v01nw47sa3agb", // FlashFlood-72h-tm3

  // Wild fire
  wildfireUSVHPIndexMapStyle: "mapbox://styles/cystellarmapbox/ckpr2mqfo0fam18l3pqexm26t",

  // Hail mapbox style
  hailMapStyle: "mapbox://styles/cystellarmapbox/ckc2eg82500my1il54yig6sx9",
  largeHailRiskUSMapboxStyle: "mapbox://styles/cystellarmapbox/ckq5l9ce65dok17mgiiv5h740",
  xlargeHailRiskUSMapboxStyle: "mapbox://styles/cystellarmapbox/ckq6l8pjt0rge18sat18mi0hs",

  largeHailRiskITAMapboxStyleV1: "mapbox://styles/cystellarmapbox/ckuqwfvtv3iu217mr0wxm71us",
  largeRCP45HailRiskITAMapboxStyleV1: "mapbox://styles/cystellarmapbox/ckuwoq68cgox017s0h80ttcks",
  largeRCP85HailRiskITAMapboxStyleV1: "mapbox://styles/cystellarmapbox/ckuwr6aaz0p5u17mv9zu79qbd",
  exLargeHailRiskITAMapboxStyleV1: "mapbox://styles/cystellarmapbox/ckuqxvqejg1gb18qjtbpnadq5",
  exLargeRCP45HailRiskITAMapboxStyleV1: "mapbox://styles/cystellarmapbox/ckuwrgoj3grke17s0m3ocvlcd",
  exLargeRCP85HailRiskITAMapboxStyleV1: "mapbox://styles/cystellarmapbox/ckuwrolc810of17qgw7enomn2",

  largeHailRiskITAMapboxStyle: "mapbox://styles/cystellarmapbox/cm2t9kk5h00fn01quabdq4y86", // RealeRisk-Hail-Large-Curr-tm3
  largeRCP45HailRiskITAMapboxStyle: "mapbox://styles/cystellarmapbox/cm35u06xv00qd01qt0zi7d7q0",
  largeRCP85HailRiskITAMapboxStyle: "mapbox://styles/cystellarmapbox/cm35u02iu001x01pf5bk07ofg",
  exLargeHailRiskITAMapboxStyle: "mapbox://styles/cystellarmapbox/cm35u0o5901ak01qw1xce66bi",
  exLargeRCP45HailRiskITAMapboxStyle: "mapbox://styles/cystellarmapbox/cm35u0h4y00cu01nw8vg95fi8",
  exLargeRCP85HailRiskITAMapboxStyle: "mapbox://styles/cystellarmapbox/cm35u0dct00q901qzab4q3ego",

  // Tornado mapbox style
  tornadoAllCatRiskMapboxStyle: "mapbox://styles/cystellarmapbox/ckq9m5vb828f317qk0poq3k5d",
  tornadoEF1CatRiskMapboxStyle: "mapbox://styles/cystellarmapbox/ckq9mbmdq02na18mvqvoekk7a",
  tornadoEF2CatRiskMapboxStyle: "mapbox://styles/cystellarmapbox/ckq9mf3wb0fqh17qvl4su4f35",
  tornadoEF4CatRiskMapboxStyle: "mapbox://styles/cystellarmapbox/ckq9mh37o13b617rxkwz43ysb",

  // WindStorm mapbox style
  windStormUS50RiskMapboxStyle: "mapbox://styles/cystellarmapbox/ckq9r9mgm1jc217u5zk7w30xn",
  windStormUS5064RiskMapboxStyle: "mapbox://styles/cystellarmapbox/ckq9rdxk907ww18rz310zs4on",
  windStormUS64RiskMapboxStyle: "mapbox://styles/cystellarmapbox/ckq9rgaml0qvs18qttlsathpc",

  windPowerDensityMapboxStyle: "mapbox://styles/cystellarmapbox/ckrz4xp64cp8v17o04l78l0ct",
  windSpeedMapboxStyle: "mapbox://styles/cystellarmapbox/ckryzee9k3n9u18mugxquiwsf",

  // Seismic
  seismicClassificationITARiskStylePB: "mapbox://styles/cystellarmapbox/ckta5ljbc3ii618phfv55hibf",
  seismicClassificationITARiskLighterStyle: "mapbox://styles/cystellarmapbox/cls3dngu6017h01qyavrd2t67",
  seismicClassificationITARiskStyle: "mapbox://styles/cystellarmapbox/cm2t3sy8700ei01o0d9yx4aci", // Seismic23-tm1

  seismicNatcatRiskStylePB: "mapbox://styles/cystellarmapbox/clvv2l204022201qz25y52r04",
  seismicNatcatRiskStyle: "mapbox://styles/cystellarmapbox/cm2swjdf900eu01qt1y3v0ksx", // Howden-earthquake+tm1-no-land
  seismicNatcat2RiskStyle: "mapbox://styles/cystellarmapbox/cm735159o01nh01r50akcd1n9",
  //"mapbox://styles/cystellarmapbox/cm735159o01nh01r50akcd1n9", //"mapbox://styles/cystellarmapbox/cm71xskxv01mt01qxa2rm4y3m",
  seismicRiskGemIsl: "mapbox://styles/cystellarmapbox/cm9wjhk9400ii01pgb2l37rjf",
  seismicRiskGemGlobal: "mapbox://styles/cystellarmapbox/cm35w6e74002c01pf64b2atyt",

  //ISPRA
  inlandFloodIspraMapboxStyleV1: "mapbox://styles/cystellarmapbox/clst21omn011801pf6wa4697d",
  inlandFloodIspraMapboxStyle: "mapbox://styles/cystellarmapbox/cm35xs5x000qr01qtg0xk81m8",

  landSlideIspraMapboxStyleV1: "mapbox://styles/cystellarmapbox/cltfs5af0000t01pj8cdc0l8w",
  landSlideIspraMapboxStyle: "mapbox://styles/cystellarmapbox/cm2swrsn100dg01o08qpthz5y", // ISPRA-landslide+tm1

  // Snow
  snow5CMMapboxStyleV1: "mapbox://styles/cystellarmapbox/ckuwepdh3773k18qvzlxrkqul",
  snow25CMMapboxStyleV1: "mapbox://styles/cystellarmapbox/ckuwgihx6o7x018s0zdnbalbr",

  snow5CMMapboxStyle: "mapbox://styles/cystellarmapbox/cm35w8792019q01pi4wlq0qoh",
  snow25CMMapboxStyle: "mapbox://styles/cystellarmapbox/cm35wbck201au01qwcnvpcruf",

  //High Wind (ITA)
  highWindITASevereMapboxStyleV1: "mapbox://styles/cystellarmapbox/ckvusw5133ayi15pbo8q55138",
  highWindITASevereRCP45MapboxStyleV1: "mapbox://styles/cystellarmapbox/ckvw8jp3j1w9h15qv2tlw5e0c",
  highWindITASevereRCP85MapboxStyleV1: "mapbox://styles/cystellarmapbox/ckvw91zhm0lf614pb7us2vwhh",

  highWindITAExtremeMapboxStyleV1: "mapbox://styles/cystellarmapbox/ckvv0hfkt011i15q9n6j7z4cy",
  highWindITAExtremeRCP45MapboxStyleV1: "mapbox://styles/cystellarmapbox/ckvwa3dnh4qf314plswyemk4p",
  highWindITAExtremeRCP85MapboxStyleV1: "mapbox://styles/cystellarmapbox/ckvwasqms0n2e14pbicah0bqu",

  highWindITASevereMapboxStyle: "mapbox://styles/cystellarmapbox/cm35wndoq00xk01pq8ns1931e",
  highWindITASevereRCP45MapboxStyle: "mapbox://styles/cystellarmapbox/cm35wnydo01av01o0bcns0nnq",
  highWindITASevereRCP85MapboxStyle: "mapbox://styles/cystellarmapbox/cm35wo3ih01ax01qw87d4bm1x",

  highWindITAExtremeMapboxStyle: "mapbox://styles/cystellarmapbox/cm35wigs900ql01qt0pcp2ha0",
  highWindITAExtremeRCP45MapboxStyle: "mapbox://styles/cystellarmapbox/cm35wn9mn01au01o02t3d4bfq",
  highWindITAExtremeRCP85MapboxStyle: "mapbox://styles/cystellarmapbox/cm35wn5xg00c001pdbpxf86j1",

  // Lightning strike
  lightningStrikeMapboxStyleV1: "mapbox://styles/cystellarmapbox/cleljk2xw008301lku2s53bom",
  lightningStrikeMapboxStyle: "mapbox://styles/cystellarmapbox/cm35xkxsu002l01pffjtgeb6b",

  //Reale group
  realeGroupHail: "mapbox://styles/cystellarmapbox/cm34lod8o00m501qtfnp48h55",
  realeGroupWind: "mapbox://styles/cystellarmapbox/cm34mb0bz001301nwgo5203dw",

  digitalElevationModelSweMapStyle: "mapbox://styles/cystellarmapbox/cmg0v1fwg002s01schxbgb97s",
  digitalElevationModelItaMapStyle: "mapbox://styles/cystellarmapbox/cmg3x68ik003p01qza5627dxz",
  heightAboveNearestDrainageSweMapStyle: "mapbox://styles/cystellarmapbox/cmg7y9gm9005e01sa5gs5hkr9",
  heightAboveNearestDrainageItaMapStyle: "mapbox://styles/cystellarmapbox/cmg7itq0w00ck01s70czx8f4x",

  // Population density, Styles/V3/cys-soce-popld
  populationDensityEurStat22021MapStyle: "mapbox://styles/cystellarmapbox/cmg9g4s8n001p01sacd11d674",
  populationDensityWorldMapStyle: "mapbox://styles/cystellarmapbox/cmg58xhjc005w01qw68ijhsml",
  populationDensityUsaMapStyle: "mapbox://styles/cystellarmapbox/cmg5an9wv008i01que03z38pd",

  distanceToNearestCoastWorldMapStyle: "mapbox://styles/cystellarmapbox/cmghzlk9x009i01qu3qoibhyl",
  distanceToNearestCoastItaMapStyle: "mapbox://styles/cystellarmapbox/cmgi6ilxk00n601seef8z25qd",
};
